import { useQuery } from '@tanstack/react-query';
import http from 'helpers/requests';
import queryClient from '../../../queryClient';

const searchOperatorInstallations = async ({ form, pagination }) => {
  const response = await http.post('/installations/operator/search', {
    ...form,
    page: pagination?.page ?? 1,
    items: pagination?.limit ?? 10,
  });
  return {
    installations: response.data?.installations || [],
    itemCount: response.data?.itemCount || 0,
  };
};

export const useFetchOperatorInstallations = ({ form, pagination }) => {
  return useQuery({
    queryKey: ['operatorInstallations', form, pagination?.page, pagination?.limit],
    queryFn: () => searchOperatorInstallations({ form, pagination }),
    enabled: !!form && !!pagination?.page && !!pagination?.limit,
  });
};

export const useFetchAllOperatorInstallations = (form) =>
  useQuery({
    queryKey: ['operatorInstallations', form, 'all'],
    queryFn: () => searchOperatorInstallations({ form, pagination: { page: 1, limit: 0 } }),
    enabled: !!form,
  });

// Awaitable variant for flows that must not proceed with an empty
// installation list (e.g. emissions report generation). Pass the same
// form/pagination the hook was mounted with so this joins its in-flight
// request (or serves the fresh cache) instead of fetching a duplicate.
export const ensureOperatorInstallations = ({ form, pagination }) =>
  queryClient.fetchQuery({
    queryKey: ['operatorInstallations', form, pagination?.page, pagination?.limit],
    queryFn: () => searchOperatorInstallations({ form, pagination }),
  });
